exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.finnix[data-v-be13dfb6] {\n  color: white;\n  background-color: #264A9A;\n}\n.finnix-bg[data-v-be13dfb6] {\n  background-color: #264A9A;\n  position: fixed;\n  top: 0;\n  left: 0;\n  min-width: 100%;\n  min-height: 100%;\n}\n.fininx-download-btn[data-v-be13dfb6] {\n  background-color: #F25942;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-be13dfb6","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/information/Finnix.vue
// module id = 1655
// module chunks = 0